// import './wdyr';

import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './util/reportWebVitals';
import Keycloak from 'keycloak-js';
import Main from './main';
import axios from 'axios';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.scss';
import i18next from './app/translation';
import cornerstone from 'cornerstone-core';
import cornerstoneMath from 'cornerstone-math';
import cornerstoneTools from 'cornerstone-tools';
import Hammer from 'hammerjs';
import SimpleTextTool from './util/tools/simpleTextTool';
import registerLoaders from './util/cornerstoneLoaderWeb/registerLoaders';
import PanToolBroadcast from './util/tools/panToolWithBroadcast';
import moment from 'moment';
import {Auth} from './login/auth';
import LoginMain from './login/loginMain';
import {zoomToolConfiguration, zoomToolStrategies} from './util/tools/zoomToolStrategies';
import LengthToolEyonix from './util/tools/LengthToolEyonix';
import ArrowAnnotateToolEyonix from './util/tools/ArrowAnnotateToolEyonix';

import FreehandRoiToolEyonix from './util/tools/FreehandRoiToolEyonix';
import FreehandRoiPDTToolEyonix from './util/tools/FreehandRoiPDTToolEyonix';
import TextMarkerToolEyonix from './util/tools/TextMarkerToolEyonix';
import EllipticalRoiToolEyonix from './util/tools/EllipticalRoiToolEyonix';
import RectangleRoiToolEyonix from './util/tools/RectangleRoiToolEyonix';
import AngleToolEyonix from './util/tools/AngleToolEyonix';
import FormAnnotateToolEyonix from './util/tools/FormAnnotateToolEyonix';
import GridToolEyonix from './util/tools/GridToolEyonix';
import TextMarkerResizeToolEyonix from './util/tools/TextMarkerResizeToolEyonix';

const cursors = cornerstoneTools.import("tools/cursors");
// const cursor = cursors.arrowAnnotateCursor; // `MouseCursor` class
const cursor = cursors.zoomCursor; // `MouseCursor` class

const BaseTool = cornerstoneTools.importInternal("base/BaseTool");

class DummyClearTool extends BaseTool {
  constructor(name = "DummyClear") {
    super({
      name,
      supportedInteractionTypes: ["Mouse"],
      svgCursor: cursor,
    });
  }

  activeCallback(element) {
    // console.log(`Hello element ${element.uuid}!`);
  }

  disabledCallback(element) {
    // console.log(`Goodbye element ${element.uuid}!`);
  }
}

axios.interceptors.request.use(
  function (config) {
    let token = window.keycloak ? window.keycloak.token : window.auth.token;
    config.headers["Authorization"] = "Bearer " + token;
    config.withCredentials = window.envConfig.hasOwnProperty("withCredentials")
      ? window.envConfig.withCredentials
      : true;
    config.headers["Accept"] = config.headers["Force-Accept"]
      ? config.headers["Force-Accept"]
      : "*/*";
    delete config.headers["Force-Accept"];
    if (config.headers.autoRefresh) {
      delete config.headers.autoRefresh;
    } else {
      window._lastRequest = moment().valueOf();
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const max_time = 3;
let counter = {};

axios.interceptors.response.use(
  (response) => {
    // Reset counter
    if (
      response?.request?.responseURL &&
      counter[response?.request?.responseURL]
    )
      counter[response.request.responseURL] = 0;

    return response;
  },
  (error) => {
    const originalRequest = error.config;
    // If user is not authenticated then logout
    if (
      window.auth &&
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      window.auth.logout();
    }

    // Create entry for request URL
    if (originalRequest?.url && !counter[originalRequest?.url])
      counter[originalRequest.url] = 0;

    // Retry mechanism
    // To cancel retry function for request, add the "stopRetry: true" parameter to the request
    if (
      originalRequest?.url &&
      counter[originalRequest.url] < max_time &&
      !originalRequest?.stopRetry &&
      error?.response?.status !== 403         // Access Forbidden - don't re-try
    ) {
      counter[originalRequest.url]++;
      return Promise.resolve(axios(originalRequest));
    }
    return Promise.reject(error);
  },
);

const originalWarn = console.warn;
console.warn = (...args) => {
    if (args[0] && args[0].includes('The value provided to Autocomplete is invalid.')) {
        return;
    }
    originalWarn(...args);
};

const onAuthorized = function (token) {
  if (process.env.BUILD_MODULE !== "agyle") {
    const userName = window.keycloak
      ? window.keycloak.tokenParsed.name
      : window.auth.tokenParsed.name;

    registerLoaders(cornerstone);

    cornerstoneTools.external.cornerstone = cornerstone;
    cornerstoneTools.external.Hammer = Hammer;
    cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
    cornerstoneTools.init({
      showSVGCursors: true,
      globalToolSyncEnabled: true,
    });

    // console.log("cornerstoneTools.ZoomTool.svgCursor", cornerstoneTools.ZoomTool.svgCursor);

    // cornerstoneTools.toolColors.setActiveColor('rgb(255, 0, 0)');
    // cornerstoneTools.textStyle.setFont(`16px Times New Roman`);
    cornerstoneTools.textStyle.setFont(`9px Roboto`);
    cornerstoneTools.textStyle.setBackgroundColor("rgba(0, 0, 0, 0.5)");

    cornerstoneTools.toolColors.setActiveColor("#ff5f50");
    cornerstoneTools.toolColors.setToolColor("rgb(34,128,247)");

    cornerstoneTools.toolStyle.setToolWidth(3);

    // const cursors = cornerstoneTools.import('tools/cursors');
    // const cursor = cursors.arrowAnnotateCursor; // `MouseCursor` class
    // console.log("cursor", cursor, cursor.getIconWithPointerSVG());

    cornerstoneTools.addTool(DummyClearTool);

    cornerstoneTools.addTool(cornerstoneTools.ZoomTool, {
      strategies: {
        default: (event) => {
          zoomToolStrategies(event);
        },
      },
      configuration: zoomToolConfiguration,
      // svgCursor: cursor,
      // svgCursor: cursors.zoomCursor,
    });
    cornerstoneTools.addTool(cornerstoneTools.PanTool);
    cornerstoneTools.addTool(cornerstoneTools.MagnifyTool);
    cornerstoneTools.addTool(PanToolBroadcast);
    cornerstoneTools.addTool(SimpleTextTool);

    cornerstoneTools.addTool(ArrowAnnotateToolEyonix, {
      user: userName,
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
    });

    cornerstoneTools.addTool(FormAnnotateToolEyonix, {
      user: userName,
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
    });

    cornerstoneTools.addTool(GridToolEyonix);

    cornerstoneTools.addTool(cornerstoneTools.BidirectionalTool);

    cornerstoneTools.addTool(LengthToolEyonix, {
      user: userName,
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
    });
    cornerstoneTools.addTool(EllipticalRoiToolEyonix, {
      user: userName,
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
    });
    cornerstoneTools.addTool(RectangleRoiToolEyonix, {
      user: userName,
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
    });
    cornerstoneTools.addTool(AngleToolEyonix, {
      user: userName,
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
    });

    cornerstoneTools.addTool(FreehandRoiToolEyonix, {
      user: userName,
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
    });
    cornerstoneTools.addTool(FreehandRoiPDTToolEyonix, {
      user: userName,
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
    });

    cornerstoneTools.addTool(cornerstoneTools.EraserTool);

    cornerstoneTools.addTool(TextMarkerToolEyonix, {
      user: userName,
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
      configuration: {
        // markers: ['F5', 'F4', 'F3', 'F2', 'F1'],

        // double click to edit label ???

        markers: [i18next.t("double click to edit text")],
        current: i18next.t("double click to edit text"),
        ascending: true,
        loop: true,
        changeTextCallback: (data, eventData, doneChangingTextCallback) => {
          const customDoneChangingTextCallback = () => {
            doneChangingTextCallback(
              data,
              document.getElementById("annotation-text").value,
            );

            document.getElementById("text-tool-modal").style.display = "none";

            document
              .getElementById("save-annotation")
              .removeEventListener("click", customDoneChangingTextCallback);
            document
              .getElementById("save-annotation")
              .removeEventListener("click", closeModal);
          };

          const closeModal = () => {
            document.getElementById("text-tool-modal").style.display = "none";

            document
              .getElementById("save-annotation")
              .removeEventListener("click", customDoneChangingTextCallback);
            document
              .getElementById("save-annotation")
              .removeEventListener("click", closeModal);
          };

          if (data.text !== "double click to edit text")
            document.getElementById("annotation-text").value = data.text;
          else document.getElementById("annotation-text").value = "";

          document.getElementById("text-tool-modal").style.display = "block";

          document
            .getElementById("save-annotation")
            .addEventListener("click", customDoneChangingTextCallback);
          document
            .getElementById("cancel-annotation")
            .addEventListener("click", closeModal);
        },
      },
    });
    cornerstoneTools.addTool(TextMarkerResizeToolEyonix, {
      user: userName,
      name: "TextMarkerResize",
      momentLib: moment,
      defaultDateTimeFormat: window.envConfig.defaultDateTimeFormat,
      configuration: {
        // markers: ['F5', 'F4', 'F3', 'F2', 'F1'],

        // double click to edit label ???

        markers: [i18next.t("double click to edit text")],
        current: i18next.t("double click to edit text"),
        ascending: true,
        loop: true,
        changeTextCallback: (data, eventData, doneChangingTextCallback) => {
          const customDoneChangingTextCallback = () => {
            doneChangingTextCallback(
              data,
              document.getElementById("annotation-text").value,
            );

            document.getElementById("text-tool-modal").style.display = "none";

            document
              .getElementById("save-annotation")
              .removeEventListener("click", customDoneChangingTextCallback);
            document
              .getElementById("save-annotation")
              .removeEventListener("click", closeModal);
          };

          const closeModal = () => {
            document.getElementById("text-tool-modal").style.display = "none";

            document
              .getElementById("save-annotation")
              .removeEventListener("click", customDoneChangingTextCallback);
            document
              .getElementById("save-annotation")
              .removeEventListener("click", closeModal);
          };

          if (data.text !== "double click to edit text")
            document.getElementById("annotation-text").value = data.text;
          else document.getElementById("annotation-text").value = "";

          document.getElementById("text-tool-modal").style.display = "block";

          document
            .getElementById("save-annotation")
            .addEventListener("click", customDoneChangingTextCallback);
          document
            .getElementById("cancel-annotation")
            .addEventListener("click", closeModal);
        },
      },
    });
  }

  // Verify environment variable
  if (!process.env.BUILD_MODULE) {
    console.error(`BUILD_MODULE is not set`);
  }

  // Verify that the 'root' element exists
  const root = document.getElementById("root");
  if (!root) {
    console.error(`'root' element not found`);
  }

  let renderByENV = (
      <Suspense fallback={<div>Loading... </div>}>
        <Main />
      </Suspense>
  );

  ReactDOM.render(renderByENV, document.getElementById("root"));

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};

const oAuthProcedure = () => {
  window.auth = new Auth();
  if (tokenFromParams) window.auth.setTokenFromParams(tokenFromParams);
  window.auth.loadTokenFromStorage();

  if (window.auth.authenticated) {
    onAuthorized(window.auth.token);
  } else {
    let renderByENV = (
        <Suspense fallback={<div>Loading... </div>}>
          <LoginMain />
        </Suspense>
    );
    ReactDOM.render(renderByENV, document.getElementById("root"));
  }
};

const oKeycloakInit = () => {
  window.keycloak = Keycloak("/keycloak.json");
  window.keycloak
    .init({
      onLoad: "login-required",
      checkLoginIframe: false,
    })
    .then((init) => {
      if (init) {
        onAuthorized(window.keycloak.token);
      } else {
        // not need to be handled
      }
    });
};

const params = new URLSearchParams(window.location.search);
const tokenFromParams = params.get("token");

switch (process.env.BUILD_MODULE) {
  case "agyle":
    oAuthProcedure();
    break;
  case "main":
  case "eyonix":
    if (tokenFromParams) {
      //set and check if incorrect then keycloak procedure init!!
      window.auth = new Auth();
      window.auth.setTokenFromParams(tokenFromParams);
      window.auth.loadTokenFromStorage();
      if (window.auth.authenticated) {
        //onAuthorized(window.auth.token);
        window.auth.loadUserInfo().then(
          () => {
            onAuthorized(window.auth.token);
          },
          () => {
            delete window.auth;
            oKeycloakInit();
          },
        );
      } else {
        delete window.auth;
        oKeycloakInit();
      }
    } else {
      window.auth = new Auth();
      window.auth.loadTokenFromStorage();
      if (window.auth.authenticated) {
        //onAuthorized(window.auth.token);
        window.auth.loadUserInfo().then(
          () => {
            onAuthorized(window.auth.token);
          },
          () => {
            delete window.auth;
            oKeycloakInit();
          },
        );
      } else {
        delete window.auth;
        oKeycloakInit();
      }
    }
    break;
  case "dch":
  case "lwh":
  case "mse":
  case "stg":
  default:
    oKeycloakInit();
    break;
}
